import React, { useEffect, useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import { Check, ContentCopy } from '@mui/icons-material';

import { useTranslation } from 'react-i18next';
import { StyledCopyableButton } from './index.style';

const CopyableButton = ({ content, color, fontSize = 24, dataAttribute }) => {
  const [copied, setCopied] = useState(false);

  const { t } = useTranslation();

  const handleClickCopy = (e) => {
    e.stopPropagation();
    if (content) {
      navigator.clipboard.writeText(content);
      setCopied(true);
    }
  };

  useEffect(() => {
    if (copied) {
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  }, [copied]);

  return (
    <StyledCopyableButton color={color}>
      {!copied && (
        <Box
          className="icon-container"
          onClick={handleClickCopy}
          {...dataAttribute}
        >
          <ContentCopy className="copy" sx={{ fontSize }} />
        </Box>
      )}
      {copied && (
        <Box className="icon-container">
          <Tooltip title={copied ? t('copied') : ''} placement="right">
            <Check className="check" sx={{ fontSize }} />
          </Tooltip>
        </Box>
      )}
    </StyledCopyableButton>
  );
};

export default CopyableButton;
